import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'My Importers',
		url: '/importers',
		icon: 'suitcase',
	},
];

export default class Importer extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/importers/${this.props.id}`,
				icon: 'suitcase',
			}
		]);
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Importer" value="details"/>
					{this.props.userAccess <= Access.Manager && <Tab label="Change Log" value="logs"/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Importer
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{this.state.tab === 'logs' && this.props.userAccess <Access.Supervisor &&
					<Collections.LogsImporters
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}
				{/*{this.state.tab === 'duplicates' &&*/}
				{/*	<Collections.DealerDuplicates*/}
				{/*		parent={this.props.match.params.id}*/}
				{/*		history={this.props.history}*/}
				{/*		locations={this.props.locations}*/}
				{/*		states={this.props.states}*/}
				{/*		reloadShell={this.props.reloadShell}*/}
				{/*		reloadPage={this.refreshPage}*/}
				{/*		reloadSelf={this.state.refresh}*/}
				{/*	/>}*/}
			</div>
		)
	}
};